import { render, staticRenderFns } from "./ScriptLoaderVideo.vue?vue&type=template&id=f8db09e6&"
import script from "./ScriptLoaderVideo.vue?vue&type=script&lang=js&"
export * from "./ScriptLoaderVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports